<div class="b-a pos-relative swatch-outer pe-none inline-block"
     [ngClass]="selected ? 'b-col-b' : 'b-col-t'">
    <div [ngClass]="optionBig ? 'swatch-inner--big' : optionHuge ? 'swatch-inner--huge' :  optionSmall ? 'swatch-inner--small' : 'swatch-inner'"
         [class.ratio-1-1]="option.hasImage"
         [class.is-checked]="selected"
         [style.background-color]="option.swatch || '#CFD2D3'"
         [bgContrast]="option.swatch || ''"
         [tolerance]="250">
        @if (option.hasImage) {
        <img class="rf"
             [image]="option.swatch" />
        }
    </div>
</div>